/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ODataServiceDocument } from '../../models/o-data-service-document';

export interface Odata$JsonOdataMetadataNoneOdataStreamingTrue$Params {
}

export function odata$JsonOdataMetadataNoneOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: Odata$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
  const rb = new RequestBuilder(rootUrl, odata$JsonOdataMetadataNoneOdataStreamingTrue.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ODataServiceDocument>;
    })
  );
}

odata$JsonOdataMetadataNoneOdataStreamingTrue.PATH = '/odata';
